




















import { defineComponent, computed } from '@vue/composition-api';
import { NavigationItem } from './navigation';
import { getStore } from '../store';

const componentName = 'page-path';

export default defineComponent({
    props: {},
    name: componentName,

    setup(props, context) {
        const store = getStore();

        const showNavigation = computed(() => navigation.value && navigation.value.length > 0);

        const navigation = computed(() => store.state.navigation && store.state.navigation.navigation);

        const showMenu = computed(() => menu.value && menu.value.length > 0);

        const menu = computed(() => store.state.navigation && store.state.navigation.menu);

        return {
            showNavigation,
            navigation,
            showMenu,
            menu
        }

    }
})

